import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Icon, Modal, message } from "antd";
import { OrderedMap, Map } from "immutable";
import { INPUT_TYPES } from "constants";
import cx from "classnames";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import shortID from "uuid/v4";
import CompanyService from "services/company-service";
import { COMPANY_TYPES } from "../../../constants";
import CompanyLosService from "../services/company-los-services";

// const TABLE_COLS = OrderedMap({
//     company_code: {
//         title: "Company Code",
//         dataIndex: "company_code",
//         key: "company_code",
//         fieldType: "TEXT",
//         editable: true
//     },
//     address: {
//         title: "Address",
//         dataIndex: "address",
//         key: "address",
//         fieldType: "TEXT",
//         editable: true
//     }
// });
class CompanyDataSyncProcessForm extends React.Component {
    state = {
        detailIds: new Map({}),
        removedDetails: [],
        dafaultValue: {}
    };
    onAutomateFileChange = (e) => {
        let field = this.props.form;
        console.log(field);
        if(e.target.value === true){
            field.disabled = true;
            field.rules = [];
        } else {
            field.disabled = false;
        }
    }

    componentDidMount() {
        CompanyLosService.getCompanyLosProfile(this.props.companyId).then(({data}) => {
            this.props.form.setFieldsValue({
                "primary_rm": data.primary_relationship_manager,
                "brands": data.channel_products
            });
        });
        CompanyLosService.getCompanyLosDetail(this.props.companyId).then(({data}) => {
            this.props.form.setFieldsValue({
                "program_anchor": data.program_anchor
            });
        });
        const { detailIds } = this.state;
        const newID = shortID();
        this.setState({
            detailIds: detailIds.set(newID, newID)
        });
    }


    getFormFields = (
    ) => new OrderedMap({
        // use_automate_file: {
        //     key: "use_automate_file",
        //     label: "",
        //     type: INPUT_TYPES.RADIO,
        //     defaultValue: false,
        //     options: [{ label: "Upload File", value: true }],
        //     className: "form-field fb-30",
        //     onChange: this.onAutomateFileChange
        // },
        base_file: {
            key: "base_file",
            multiple: false,
            showUploadList: false,
            label: "Upload Base File",
            type: INPUT_TYPES.FILE,
            className: "form-field fb-40",
            btnLabel: "Upload File",
            request_type: 2,
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            rules: [{
                required: true,
                message: "base file is required"
            }]
        },
        primary_rm: {
            className: "form-field fb-40 mr-10",
            type: INPUT_TYPES.OBJECT_SELECT,
            labelProp: "full_name",
            showSearch: true,
            onSearch: (search) => CompanyService.getSMList(search),
            getOptionsOnFocus: (search) => CompanyService.getSMList(search),
            label: "Primary Relationship Manager",
            filterOption: true,
            rules: [{
                required: true,
                message: "primary relationship manager is required"
            }]
        },
        program_anchor: {
            label: "Program Anchor",
            type: INPUT_TYPES.OBJECT_SELECT,
            className: "form-field fb-40 mr-10",
            showSearch: true,
            labelProp: "name",
            onSearch: (str) => CompanyService.getCompanyProfiles(COMPANY_TYPES.get("Anchor"), str),
            rules: [{
                required: true,
                message: "program anchor is required"
            }]
        },
        brands: {
            className: "form-field fb-40 mr-10",
            label: "Brands",
            type: INPUT_TYPES.OBJECT_SELECT,
            getOptionsOnFocus: (search) => CompanyService.getChannelProducts(search),
            labelProp: "name|id",
            mode: "multiple",
            filterOption: true,
            rules: [{
                required: true,
                message: "brans is required"
            }]
        },
        remarks: {
            key: "remarks",
            label: "Remark",
            type: INPUT_TYPES.TEXTAREA,
            className: "form-field fb-40",
            valuePropName: "defaultValue"
        },
        file_feedback: {
            key: "file_feedback",
            label: "Please select option",
            type: INPUT_TYPES.RADIO,
            options: [{ label: "Automated FIle Correct", value: "automated_file_correct" }, { label: "Automated FIle With Changes", value: "automated_file_with_changes" }, { label: "Manual File Used", value: "manual_file_used" }],
            className: "form-field fb-100",
            rules: [{
                required: true,
                message: "Feedback is required"
            }]
        },
    });

    detailTable = new OrderedMap({
        erp_company_name: {
            className: "form-field fb-20 mr-10",
            type: INPUT_TYPES.TEXT,
            label: "ERP Company Name",
            rules: [{
                required: true,
                message: "Field is required"
            }]
        },
        company_code: {
            className: "form-field fb-20 mr-10",
            type: INPUT_TYPES.TEXT,
            label: "Company Code",
            rules: [{
                required: true,
                message: "company code is required"
            }]
        },
        address: {
            className: "form-field fb-20",
            type: INPUT_TYPES.TEXT,
            label: "Company Address",
            rules: [{
                required: true,
                message: "address is required"
            }]
        }
    });

    toggleFormGrid = (action = "ADD", id) => {
        const { detailIds } = this.state;
        let removedDetails = this.state.removedDetails;
        const newID = shortID();
        switch (action) {
        case "ADD":
            this.setState({
                detailIds: detailIds.set(newID, newID)
            });
            break;
        case "REMOVE": {
            removedDetails.push(id);
            this.setState({
                removedDetails: removedDetails
            });
            break;
        }
        default:
        }
    };

    formFields = () => this.getFormFields({ allFieldsDisabled: this.props.loading });
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, values) => {
                if (!err) {
                    if(this.props.request_type == 1){
                        if(values.request_data){
                            values.request_data = new Map(values.request_data).toList().toArray();
                            this.props.onSubmit(values, null);
                            return;
                        } else {
                            return;
                        }
                    }
                    this.props.onSubmit(values, this.props.selected_row_data.processed);
                }
            });
        }
    }

    getFormFiels = () =>{
        let fields = this.formFields(null);
        // let use_automate_file = this.props.form.getFieldValue("use_automate_file");
        // let file_feedback = this.props.form.getFieldValue("file_feedback");
        if((this.props.request_type == 1 && this.state.detailIds) && this.state.detailIds.size){
            fields = fields.delete("use_automate_file");
            fields = fields.delete("file_feedback");
        }
        // if(use_automate_file === true){
        //     if(file_feedback === false){
        //         fields = fields.set("base_file", {
        //             key: "base_file",
        //             multiple: false,
        //             showUploadList: false,
        //             label: "Upload Base File",
        //             type: INPUT_TYPES.FILE,
        //             className: "form-field fb-40",
        //             btnLabel: "Upload File",
        //             request_type: 2,
        //             accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        //             rules: [{
        //                 required: true,
        //                 message: "base file is required"
        //             }]
        //         });
        //     }else{
        //         fields = fields.delete("base_file");
        //     }
        // }else if(use_automate_file === false){
        //     fields = fields.delete("file_feedback");
        //     fields = fields.set("base_file", {
        //         key: "base_file",
        //         multiple: false,
        //         showUploadList: false,
        //         label: "Upload Base File",
        //         type: INPUT_TYPES.FILE,
        //         className: "form-field fb-40",
        //         btnLabel: "Upload File",
        //         request_type: 2,
        //         accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        //         rules: [{
        //             required: true,
        //             message: "base file is required"
        //         }]
        //     });
        // }
        return fields;
    }

    downloadFile = (_) => {
        const link = document.createElement("a");
        link.href = _;
        if(_) {
            link.setAttribute("download", "file");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } else {
            message.error("No File available to Download");
        }
    }

    render() {
        return (
            <Modal 
                footer={null}
                width={800}
                visible={this.props.visible}
                closable={true}
                destroyOnClose={true}
                onCancel={this.props.onCancel}
            >
                <Form onSubmit={this.onValuesSubmit}>
                    <div className={"form-row mt-20 fb-100 d-flex flex-row just flex-wrap align-items-center w-100"}>
                        {this.getFormFiels()
                            .map((field, fieldName) => {
                                if(field.request_type && (field.request_type != this.props.request_type)){
                                    return;
                                }
                                if(!this.props.is_base_file_required && fieldName === "base_file"){
                                    field.rules = [];
                                }
                                // if(fieldName === "use_automate_file"){
                                //     return (<React.Fragment>{this.fieldGenerator(
                                //         fieldName,
                                //         field,
                                //         this.getValidateStatus(fieldName)
                                //     )()}{
                                //         this.props.form.getFieldsValue().use_automate_file ? <React.Fragment>
                                //             <div>
                                //                 <Button style={{
                                //                     color: "#45BE93",
                                //                     border: "0.6px solid #45BE93"
                                //                 }} onClick={() => this.downloadFile(this.props.selected_row_data.processed)} type={"default"} shape={"round"}>
                                //                     Processed Ledger <Icon type={"download"} />
                                //                 </Button>
                                //                 <Button style={{
                                //                     marginLeft: "20px",
                                //                     color: "#45BE93",
                                //                     border: "0.6px solid #45BE93"
                                //                 }} onClick={() => this.downloadFile(this.props.selected_row_data.processed_transaction)} type={"default"} shape={"round"}>
                                //                     Processed Ledger Transactions <Icon type={"download"} />
                                //                 </Button>
                                //             </div>
                                //         </React.Fragment> : null
                                //     }</React.Fragment>);
                                // }
                                return this.fieldGenerator(
                                    fieldName,
                                    field,
                                    this.getValidateStatus(fieldName)
                                )();
                            }).toList()
                        }
                        <div>
                            {
                                (this.props.request_type == 1 && this.state.detailIds) && 
                                    this.state.detailIds.size ?
                                    this.state.detailIds.toList().filter(_ => !this.state.removedDetails.length || !this.state.removedDetails.includes(_)).map(_ => (
                                        <div
                                            key={`request_data-${_}`}
                                            className="form-row form-row-compact bg-grey p-10 br-3">
                                            {this.detailTable.map((field, fieldName) => {
                                                return this.fieldGenerator(
                                                    `${"request_data"}.${_}.${fieldName}`,
                                                    field,
                                                    this.getErrorOnField(`${_}.${fieldName}`)
                                                )();
                                            }).toList()}
                                            <Form.Item className={cx("m-0 form-btn")}>
                                                <Button
                                                    shape="circle"
                                                    icon={"minus"}
                                                    onClick={this.toggleFormGrid.bind(
                                                        null,
                                                        "REMOVE",
                                                        _
                                                    )}
                                                />
                                            </Form.Item>
                                        </div>
                                    )) : null
                            }
                        </div>
                        {this.props.request_type == 1 && <div className={"form-row mt-10"}>
                            <Form.Item className={cx("form-btn m-0 d-flex")}>
                                <Button
                                    type="dashed"
                                    icon={"plus"}
                                    // disabled={this.props.formDisabled}
                                    onClick={this.toggleFormGrid.bind(null, "ADD")}>
                                    Add Company Detail
                                </Button>
                            </Form.Item>
                        </div>}
                    </div>
                    <div className={"form-row mt-10"}>
                        <div className={"flex-row-reverse"}>
                            <Button type={"primary"} htmlType={"submit"}>
                                {this.props.loading ? <Icon type={"loading"} /> : null}
                                Submit
                            </Button>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}

CompanyDataSyncProcessForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.array,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    visible: PropTypes.bool,
    toggleBrandModal: PropTypes.func,
    master_erps: PropTypes.array,
    associates: PropTypes.array,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    request_type: PropTypes.number,
    is_base_file_required: PropTypes.bool,
    companyId: PropTypes.number,
    selected_row_data: PropTypes.object
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
            values
                .map((value) => {
                    let message = null;
                    if (value === null) {
                        message = "Field cannot be empty";
                    }
                    if (message) {
                        return Form.createFormField({
                            value,
                            errors: [{ message }]
                        });
                    } else {
                        return Form.createFormField({
                            value
                        });
                    }
                }).toJS();
    }
})(CompanyDataSyncProcessForm);
